import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableHead, TableRow, Avatar, Collapse, Typography, Box } from '@material-ui/core';
import moment from 'moment';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
            fontSize: '18px'
        },
    },
});


const ReporteRow = (props) => {
    const { row, name } = props;
    const [open, setOpen] = React.useState(true);
    const classes = useRowStyles();
  
    const totalContactos = row.reduce(
        (accumulator, currentValue) => accumulator + currentValue.contactos, 0)

        
    const totalMensajes = 0;

    const visualizeDuration = (time) => {
        return moment.duration(time, "seconds").format("hh:mm:ss", { trim: false });
    }
    
    return (
        <React.Fragment>
            <TableRow className={classes.root}>
                <TableCell style={{ width : '200px'}}>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        <Avatar style={{ marginRight: 10 }}> {name.charAt(0)}</Avatar> <Typography variant="h6">{name}</Typography>
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row" style={{ padingTop : '23px' }}>
                    Total Contactos : { totalContactos }
                </TableCell>
        
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="h6" gutterBottom component="div">
                                Registros
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{width : '200px'}}>Clasificación</TableCell>
                                        <TableCell>Contactos</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.map((historyRow, index) => (
                                        <TableRow key={index}>
                                            <TableCell >{historyRow.tags}</TableCell>
                                            <TableCell>{historyRow.contactos}</TableCell>
                                           
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default ReporteRow;